import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

import Button from '@/components/Buttons/Button';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Restart from '@/images/Restart.svg';

import { useCreateAvatarStore } from '../../common/context';

export interface ConsentVideoProps {
    sourceUrl: string;
    retryText: string;
    thumbnailUrl?: string;
    fileType?: string;
}

const VideoContainer = styled.div`
    border-radius: 8px;
    position: relative;
    margin-block-start: 24px;
`;

const Video = styled.video`
    border-radius: 8px;
    width: 100%;
`;

const RetryButton = styled(Button)`
    position: absolute;
    background-color: white;
    top: 12px;
    right: 12px;
    padding: 7px 6px 7px 14px;
    height: 34px;

    font-size: 14px;
    font-weight: 600;
    line-height: 20px; /* 142.857% */

    :hover {
        background-color: ${({ theme }) => theme.colors.black[100]};
    }
`;

export const ConsentVideo = observer(({ sourceUrl, retryText, thumbnailUrl, fileType }: ConsentVideoProps) => {
    const createAvatarStore = useCreateAvatarStore();

    return (
        <VideoContainer>
            <Video controls preload="metadata" poster={thumbnailUrl}>
                <source src={sourceUrl} type={fileType} />
            </Video>
            <RetryButton
                startIcon={<MaskedIcon src={Restart} size="16px" />}
                variant="outlined"
                color="secondary"
                onClick={() => createAvatarStore.resetConsentUpload()}>
                {retryText}
            </RetryButton>
        </VideoContainer>
    );
});
